export default __webpack_public_path__ + "static/media/timer_logo.e986e751.svg";